import { BASEURL, checktoken, headers } from '../../utils/helper'
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { toastError, toastSuccess } from './other.slice';
import axios from 'axios';

const initialState = {
    data: [],
    total: 0,
    pages: 0,
    current: 0,
    error: null,
    insurance: {},
    sidebar: true,
    loading: false,
}

export const InsuranceList = createAsyncThunk('InsuranceList', async ({ role, page, country, text }, { rejectWithValue, dispatch }) => {
    try {
        const response = await axios.get(`${BASEURL}/admin/insurance/list/${role}?page=${page}&country=${country}&text=${text}`,
            { headers: headers() })
            .then((res) => {
                return res.data;
            }).catch((err) => {
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        return error;
    }
})

export const singleInsuranceReq = createAsyncThunk('singleInsuranceReq', async ({ id }, { rejectWithValue, dispatch }) => {
    try {
        const response = await axios.get(`${BASEURL}/admin/insurance/info/${id}`,
            { headers: headers() })
            .then((res) => {
                return res.data;
            }).catch((err) => {
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        return error;
    }
})

export const InsuranceDelete = createAsyncThunk('InsuranceDelete', async ({ role, id, page }, { rejectWithValue, dispatch }) => {
    try {
        const response = await axios.delete(`${BASEURL}/admin/insurance/delete/${id}`,
            { headers: headers() })
            .then((res) => {
                if (res?.data?.success) {
                    dispatch(toastSuccess(res?.data?.message))
                    dispatch(InsuranceList({ role: role, page: page ? page : 1 }))
                }
            }).catch((err) => {
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        return error;
    }
})

export const insuranceFormSlice = createSlice({
    name: 'insuranceFormSlice',
    initialState: initialState,
    reducers: {
    },
    extraReducers: (builder) => {
        builder.addCase(InsuranceList.pending, (state, action) => {
            state.loading = true
            state.total = 0
            state.pages = 0
            state.current = 0
            state.data = []
            return state
        })
        builder.addCase(InsuranceList.fulfilled, (state, action) => {
            state.loading = false
            state.data = action.payload.data
            state.total = action.payload.total
            state.pages = action.payload.pages
            state.current = action.payload.current
            return state
        })
        builder.addCase(InsuranceList.rejected, (state, action) => {
            state.loading = false
            state.data = []
            state.total = 0
            state.pages = 0
            state.current = 0
            state.error = 'Error occured'
        })

        builder.addCase(singleInsuranceReq.pending, (state, action) => {
            state.loading = true
            state.insurance = {}
            return state
        })
        builder.addCase(singleInsuranceReq.fulfilled, (state, action) => {
            state.loading = false
            state.insurance = action.payload.data
            return state
        })
        builder.addCase(singleInsuranceReq.rejected, (state, action) => {
            state.loading = false
            state.insurance = {}
            state.error = 'Error occured'
        })
        builder.addCase('LOGOUT', () => initialState)
    }
})

export default insuranceFormSlice.reducer